/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralOwnership } from './nonCadastralOwnership.model';


export interface ListResponseNonCadastralOwnership { 
    itemCount?: number;
    items?: Array<NonCadastralOwnership>;
    params?: { [key: string]: any; };
}

